import React, { useEffect, useState } from 'react';
import api from '../api';

const DEGISKENLER = [
  { key: '{{unvan}}', aciklama: 'İşyeri ünvanı' },
  { key: '{{ruhsat_no}}', aciklama: 'Ruhsat numarası' },
  { key: '{{durum}}', aciklama: 'Ruhsat durumu' },
  { key: '{{basvuru_tarihi}}', aciklama: 'Başvuru tarihi' },
  { key: '{{ad}}', aciklama: 'Sahip adı / ünvanı' },
];

export default function SmsSablonlari() {
  const [sablonlar, setSablonlar] = useState([]);
  const [modal, setModal] = useState(null); // null | {id?, sablon_adi, icerik, aciklama, aktif}
  const [yukleniyor, setYukleniyor] = useState(true);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [mesaj, setMesaj] = useState('');

  const yukle = () => {
    setYukleniyor(true);
    api.get('/sms/sablonlar').then(r => setSablonlar(r.data)).catch(() => setHata('Şablonlar yüklenemedi')).finally(() => setYukleniyor(false));
  };

  useEffect(() => { yukle(); }, []);

  const kaydet = async () => {
    setHata(''); setKaydediliyor(true);
    try {
      if (modal.id) await api.put(`/sms/sablonlar/${modal.id}`, modal);
      else await api.post('/sms/sablonlar', modal);
      setModal(null); setMesaj('Şablon kaydedildi.'); yukle();
      setTimeout(() => setMesaj(''), 3000);
    } catch (e) { setHata(e.response?.data?.hata || 'Kayıt hatası'); }
    finally { setKaydediliyor(false); }
  };

  const sil = async (id) => {
    if (!window.confirm('Bu şablonu silmek istediğinize emin misiniz?')) return;
    await api.delete(`/sms/sablonlar/${id}`).catch(() => {});
    yukle();
  };

  const degiskenEkle = (key) => {
    setModal(m => ({ ...m, icerik: (m.icerik || '') + key }));
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ color: '#1a237e', fontSize: '20px', margin: 0 }}>📱 SMS Şablonları</h2>
        <button className="btn btn-primary" onClick={() => setModal({ sablon_adi: '', icerik: '', aciklama: '', aktif: true })}>+ Yeni Şablon</button>
      </div>

      {hata && <div className="alert alert-error">{hata}</div>}
      {mesaj && <div className="alert alert-success">{mesaj}</div>}

      {/* Değişken referansı */}
      <div className="card" style={{ marginBottom: '16px' }}>
        <div className="card-header"><span className="card-title">Kullanılabilir Değişkenler</span></div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '4px 0' }}>
          {DEGISKENLER.map(d => (
            <div key={d.key} style={{ background: '#e8eaf6', borderRadius: '6px', padding: '6px 12px', fontSize: '13px' }}>
              <code style={{ color: '#3949ab', fontWeight: '600' }}>{d.key}</code>
              <span style={{ color: '#666', marginLeft: '6px' }}>{d.aciklama}</span>
            </div>
          ))}
        </div>
      </div>

      {yukleniyor ? (
        <div className="loading">Yükleniyor...</div>
      ) : sablonlar.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
          Henüz şablon eklenmemiş. "+ Yeni Şablon" butonuyla ekleyebilirsiniz.
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '12px' }}>
          {sablonlar.map(s => (
            <div key={s.id} className="card" style={{ border: s.aktif ? '1px solid #e0e0e0' : '1px solid #f5c6c6', opacity: s.aktif ? 1 : 0.7 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <strong style={{ fontSize: '15px', color: '#1a237e' }}>{s.sablon_adi}</strong>
                    <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: s.aktif ? '#e8f5e9' : '#ffebee', color: s.aktif ? '#2e7d32' : '#c62828' }}>
                      {s.aktif ? 'Aktif' : 'Pasif'}
                    </span>
                  </div>
                  {s.aciklama && <div style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>{s.aciklama}</div>}
                  <div style={{ background: '#f8f9fa', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '10px 12px', fontSize: '13px', color: '#333', whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
                    {s.icerik}
                  </div>
                  <div style={{ fontSize: '11px', color: '#aaa', marginTop: '6px' }}>
                    {s.icerik.length} karakter
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '6px', marginLeft: '12px', flexShrink: 0 }}>
                  <button className="btn btn-outline btn-sm" onClick={() => setModal({ ...s })}>✏️ Düzenle</button>
                  <button className="btn btn-sm" style={{ background: '#ffebee', color: '#c62828', border: '1px solid #ef9a9a' }} onClick={() => sil(s.id)}>🗑️</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal && (
        <div className="form-modal-backdrop" onMouseDown={() => setModal(null)}>
          <div className="form-modal form-modal-wide" role="dialog" aria-modal="true" onMouseDown={e => e.stopPropagation()} style={{ maxWidth: '600px' }}>
            <h3>{modal.id ? 'Şablon Düzenle' : 'Yeni Şablon'}</h3>
            <div className="form-group">
              <label>Şablon Adı *</label>
              <input autoFocus value={modal.sablon_adi} onChange={e => setModal(m => ({ ...m, sablon_adi: e.target.value }))} placeholder="Örn: Başvuru Onay Bildirimi" />
            </div>
            <div className="form-group">
              <label>Açıklama</label>
              <input value={modal.aciklama} onChange={e => setModal(m => ({ ...m, aciklama: e.target.value }))} placeholder="Bu şablon ne için kullanılır?" />
            </div>
            <div className="form-group">
              <label>Mesaj İçeriği * ({(modal.icerik || '').length} karakter)</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                {DEGISKENLER.map(d => (
                  <button key={d.key} type="button" onClick={() => degiskenEkle(d.key)}
                    style={{ fontSize: '11px', padding: '3px 8px', background: '#e8eaf6', border: '1px solid #c5cae9', borderRadius: '4px', cursor: 'pointer', color: '#3949ab' }}>
                    + {d.key}
                  </button>
                ))}
              </div>
              <textarea
                value={modal.icerik}
                onChange={e => setModal(m => ({ ...m, icerik: e.target.value }))}
                rows={4}
                placeholder="Sayın {{ad}}, {{unvan}} işyerinizin ruhsat durumu {{durum}} olarak güncellenmiştir."
                style={{ fontFamily: 'monospace', fontSize: '13px' }}
              />
            </div>
            <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type="checkbox" id="sablon-aktif" checked={!!modal.aktif} onChange={e => setModal(m => ({ ...m, aktif: e.target.checked }))} />
              <label htmlFor="sablon-aktif" style={{ margin: 0 }}>Aktif</label>
            </div>
            {hata && <div className="alert alert-error" style={{ marginBottom: '8px' }}>{hata}</div>}
            <div className="form-modal-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setModal(null)}>İptal</button>
              <button type="button" className="btn btn-primary" onClick={kaydet} disabled={kaydediliyor}>
                {kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
